import apiClient from "../apiClient";

const resource = "bonuses";

export default {
    getAll: params => apiClient.get(`${resource}?${params}`),
    getEmploymentBonus: id => apiClient.get(`${resource}/${id}/bonusStatment`),
    getCurrentBonus: id => apiClient.get(`${resource}/${id}/currentBonus`),
};
